// Generated by ReScript, PLEASE EDIT WITH CARE


var address_edit_button = "Edit";

var ga_page_landing = "fe_review_land";

var ga_back_tap = "fe_estresult_back_tap";

var meta_title = "Order History | Porter";

var meta_description = "Looking to hire a mini truck? Use the Porter App. Get tata ace at doorstep in 30 mins. Faster, economical, hassle-free mini truck booking. Choose from over 3000 trained drivers & a wide range of dedicated vehicles.";

var navbar_title = "Orders";

var track_order_button = "Track Order";

var track_order_live = "Live";

var live_orders_text = "Live Orders";

var live_order_card_status = "LIVE";

var live_order_card_text = "Your order(s) are in progress";

var live_order_button = "View Status";

var error_fetching_text = "Something went wrong";

var error_fetching_sub_text = "Sorry, this is embarrassing. Please try again.";

var error_fetching_button = "Retry";

export {
  address_edit_button ,
  ga_page_landing ,
  ga_back_tap ,
  meta_title ,
  meta_description ,
  navbar_title ,
  track_order_button ,
  track_order_live ,
  live_orders_text ,
  live_order_card_status ,
  live_order_card_text ,
  live_order_button ,
  error_fetching_text ,
  error_fetching_sub_text ,
  error_fetching_button ,
}
/* No side effect */
